import throttle from 'lodash/throttle';
const $ = window.jQuery;

$(() => {
    const $search_toggle = $('.header__search-icon');

    if (!$search_toggle.length) {
        return;
    }

    const $header = $('#header');
    const $visit_info = $('#visit-info');
    const $visit_info_button = $('#visit-info-button');

    $search_toggle.on('click', () => {
        $header.toggleClass('header--search-active');
        $('body').toggleClass('header--search-active');
    });

    $visit_info_button.on('click', () => {
        if (!$visit_info.hasClass('visit-info--active')) {
            const scrollPos = $(window).scrollTop();

            if (scrollPos > 0) {
                $('html,body').animate({ scrollTop: 0 }, scrollPos * 3);
            }

            setTimeout(() => {
                $('html,body').css('overflow', 'hidden');
                $visit_info.addClass('animated fadeInUpBig visit-info--active');
                $visit_info.one('animationend', () => {
                    $visit_info.removeClass('animated fadeInUpBig');
                });
            }, scrollPos * 3);
        }
    });

    $('.visit-info__close,.visit-info__barrier').on('click', () => {
        if ($visit_info.hasClass('visit-info--active')) {
            $('html,body').css('overflow', '');
            $visit_info.addClass('animated fadeOutDownBig');
            $visit_info.one('animationend', () => {
                $visit_info.removeClass(
                    'animated fadeOutDownBig visit-info--active',
                );
            });
        }
    });

    let header_inner_offset = $('.header__inner').offset().top;
    let header_inner_height = $('.header__inner').outerHeight(true);
    let header_height = $('#header').outerHeight(true);

    $(window).on('resize orientationchange', () => {
        header_inner_offset = $('.header__inner').offset().top;
        header_inner_height = $('.header__inner').outerHeight(true);
        header_height = $('#header').outerHeight(true);
    });

    let time_since_change = Date.now();

    function setStickyClass() {
        let scroll_top = $(window).scrollTop();

        if (scroll_top < 0) {
            scroll_top = 0;
        }

        if (scroll_top > 0 && !$('body').hasClass('--sticky-header')) {
            $('body').addClass('--sticky-header');
        } else if (scroll_top <= 0 && $('body').hasClass('--sticky-header')) {
            $('body').removeClass('--sticky-header');
        }
    }

    $(window).on(
        'scroll',
        throttle(() => {
            if (Date.now() - time_since_change < 1000) {
                return;
            }

            setStickyClass();

            time_since_change = Date.now();
        }, 250),
    );

    setStickyClass();
});
